export default "__VITE_ASSET__B55wTsq1__"